import { Loader2 } from "lucide-react";

export default function SlackConnectLoad() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-midnight to-dark-teal text-white flex items-center justify-center p-4">
      <div className="bg-steel/30 backdrop-blur-sm rounded-xl p-8 shadow-xl border border-steel/50 w-full max-w-md text-center">
        <div className="mx-auto mb-4">
          <Loader2 className="h-12 w-12 animate-spin text-cyan" />
        </div>
        <h2 className="text-xl font-medium text-white mb-3">Connecting your Slack account...</h2>
        <p className="text-slate-300">
          Please wait while we link your account.
        </p>
      </div>
    </div>
  );
}
